export default __webpack_public_path__ + "static/media/9.8796fb32.png";